(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-qr", [], factory);
	else if(typeof exports === 'object')
		exports["vue-qr"] = factory();
	else
		root["vue-qr"] = factory();
})(this, function() {
return 